import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../Sidebar';
import Header from '../Header';
import { useTheme } from '../../context/ThemeContext';

/**
 * Shared PageLayout component that provides consistent layout 
 * with Sidebar and Header for all pages
 */
const PageLayout = ({ children, userName = 'User', showHeader = true }) => {
    const { isDark } = useTheme();

    return (
        <div className={`min-h-screen transition-colors duration-300 ${isDark ? 'bg-dark-primary' : 'bg-gray-50'
            }`}>
            <div className="flex flex-col md:flex-row min-h-screen">
                {/* Sidebar */}
                <Sidebar />

                {/* Main content area */}
                <div className="flex-1 flex flex-col">
                    {/* Header */}
                    {showHeader && <Header userName={userName} />}

                    {/* Page content */}
                    <div className="flex-1">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

PageLayout.propTypes = {
    children: PropTypes.node.isRequired,
    userName: PropTypes.string,
    showHeader: PropTypes.bool,
};

export default PageLayout;
